<template>
  <div>
    <v-col v-for="item in myLists" :key="item.id" cols="12">
      <list-item :item="item" />
    </v-col>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import { mapState } from "vuex";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  props: ['myLists'],
  data: () => ({
  }),
  components: {
    'list-item': ListItem
    },
  methods: {
  },
  computed: {
  },
  watch: {
   
  }
};
</script>
